import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b764678"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loby-root" }
const _hoisted_2 = { class: "pc-loby" }
const _hoisted_3 = { class: "left-content" }
const _hoisted_4 = { class: "user-info" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "coin" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "button-menu" }, "全部"),
  /*#__PURE__*/_createElementVNode("div", { class: "button-menu" }, "经典番摊"),
  /*#__PURE__*/_createElementVNode("div", { class: "button-menu active" }, "特色番摊")
], -1))
const _hoisted_8 = { class: "main-content" }
const _hoisted_9 = { class: "notice-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13.509",
  height: "12.767",
  viewBox: "0 0 13.509 12.767"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "icon",
    transform: "translate(0 0.23)"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Union_29",
      "data-name": "Union 29",
      d: "M-11303.674-1365.359a1,1,0,0,1-.116-1.408c1.792-2.11,2.155-6.991.009-9.467a1,1,0,0,1,.1-1.408,1,1,0,0,1,1.411.1c2.87,3.311,2.351,9.31.008,12.07a1,1,0,0,1-.764.352A1,1,0,0,1-11303.674-1365.359Zm-4.887-.457-2.3-2.152v-7.317l2.3-1.721c1-.7,1.642.1,1.642,1.292v8.606c0,.88-.413,1.563-.989,1.563A1.046,1.046,0,0,1-11308.561-1365.816Zm2.477-1.266a1,1,0,0,1-.2-1.4,5.1,5.1,0,0,0,1.037-3.086,5.083,5.083,0,0,0-.991-3.021,1,1,0,0,1,.222-1.4,1,1,0,0,1,1.4.219,7.1,7.1,0,0,1,1.374,4.2,7.091,7.091,0,0,1-1.439,4.287,1,1,0,0,1-.8.4A.988.988,0,0,1-11306.084-1367.083Zm-6.091-.886a1.949,1.949,0,0,1-1.641-2.152v-3.013a1.951,1.951,0,0,1,1.641-2.152h.985v7.317Z",
      transform: "translate(11313.815 1377.658)",
      fill: "#665353"
    })
  ])
], -1))
const _hoisted_11 = { class: "notice" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<g id=\"Group_201\" data-name=\"Group 201\" transform=\"translate(1 2)\" data-v-9b764678><path id=\"Polygon_12\" data-name=\"Polygon 12\" d=\"M2.606,1.789a1,1,0,0,1,1.789,0L6.276,5.553A1,1,0,0,1,5.382,7H1.618A1,1,0,0,1,.724,5.553Z\" transform=\"translate(-1 10) rotate(-90)\" fill=\"#665353\" data-v-9b764678></path><rect id=\"Rectangle_392\" data-name=\"Rectangle 392\" width=\"9\" height=\"3\" rx=\"1.5\" transform=\"translate(9 5)\" fill=\"#665353\" data-v-9b764678></rect><rect id=\"Rectangle_393\" data-name=\"Rectangle 393\" width=\"18\" height=\"3\" rx=\"1.5\" transform=\"translate(0 -2)\" fill=\"#665353\" data-v-9b764678></rect><rect id=\"Rectangle_394\" data-name=\"Rectangle 394\" width=\"18\" height=\"3\" rx=\"1.5\" transform=\"translate(0 12)\" fill=\"#665353\" data-v-9b764678></rect></g>", 1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-root" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_coin = _resolveComponent("svg-coin")!
  const _component_marquee_text = _resolveComponent("marquee-text")!
  const _component_fantan_list_item = _resolveComponent("fantan-list-item")!
  const _component_list_item = _resolveComponent("list-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["avatar", `avatar${_ctx.avatar}`]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialog('avatar')))
          }, null, 2),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_svg_coin),
            _createTextVNode(_toDisplayString(_ctx.coin), 1)
          ])
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createBlock(_component_marquee_text, {
              class: "d-notice",
              speed: 30,
              key: _ctx.noticeKey
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.notice), 1)
              ]),
              _: 1
            }))
          ]),
          (_openBlock(), _createElementBlock("svg", {
            id: "Component_28_5",
            "data-name": "Component 28 – 5",
            xmlns: "http://www.w3.org/2000/svg",
            width: "19",
            height: "17",
            viewBox: "0 0 19 17",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog('setting')))
          }, _hoisted_13))
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(), _createElementBlock("div", {
            class: "list-wrap",
            key: _ctx.listKey
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desks, (desk) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: desk.tableNo
              }, [
                (desk.gameType === 3)
                  ? (_openBlock(), _createBlock(_component_fantan_list_item, {
                      key: 0,
                      class: "list-item",
                      selected: _ctx.selectedTable,
                      mdata: desk,
                      onSelectTable: _ctx.handleSelectTable
                    }, null, 8, ["selected", "mdata", "onSelectTable"]))
                  : (_openBlock(), _createBlock(_component_list_item, {
                      key: 1,
                      mdata: desk,
                      class: "list-item"
                    }, null, 8, ["mdata"]))
              ], 64))
            }), 128))
          ]))
        ])
      ])
    ]),
    _hoisted_15
  ]))
}